import { createUseStyles } from "react-jss";

export const ManagementParkingValidationRuleContainerStyle = createUseStyles((theme: any) => ({
    generalContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.gaps.sizes.base,
    },
}));
